import { render, staticRenderFns } from "./part-i.vue?vue&type=template&id=18d151b7&"
import script from "./part-i.vue?vue&type=script&lang=js&"
export * from "./part-i.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports